import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { PanZoom } from 'react-easy-panzoom'
import axios from 'axios'
import { generateProtobufDiagram } from 'src/views/dashboard/DashboardFunctions'
import { CONSTANTS } from '../Constants'
import { MapContainer } from 'react-leaflet'
import { CircularProgress } from '@mui/material'

const Protobuf = ({
  panZoomRef,
  setOpenSnackbar,
  setOpenSnackbarDiagram,
  setSnackbarMessage,
  setSnackbarSeverity,
}) => {
  let editorValue = useSelector((state) => state.protobufEditor.protobufEditorValue)
  const [protobufImage, setProtobufImage] = useState('')
  const [loading, setLoading] = useState(true)
  const [previousCode, setPreviousCode] = useState('')
  const [initial, setInitial] = useState(true)

  const blankImage =
    'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8IS0tIEdlbmVyYXRlZCBieSBncmFwaHZpeiB2ZXJzaW9uIDIuNDMuMCAoMCkKIC0tPgo8IS0tIFRpdGxlOiBwcm90b2RvdCBQYWdlczogMSAtLT4KPHN2ZyB3aWR0aD0iOHB0IiBoZWlnaHQ9IjhwdCIKIHZpZXdCb3g9IjAuMDAgMC4wMCA4LjAwIDguMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgo8ZyBpZD0iZ3JhcGgwIiBjbGFzcz0iZ3JhcGgiIHRyYW5zZm9ybT0ic2NhbGUoMSAxKSByb3RhdGUoMCkgdHJhbnNsYXRlKDQgNCkiPgo8dGl0bGU+cHJvdG9kb3Q8L3RpdGxlPgo8L2c+Cjwvc3ZnPgo='

  axios.defaults.withCredentials = true

  // useEffect(() => {
  //   if (panZoomRef.current) {
  //     panZoomRef.current.setOptions({ preventScroll: true });
  //   }
  // }, [panZoomRef]);

  useEffect(() => {
    const generateProtobufImage = async () => {
      try {
        if(!editorValue.trim()){
          setProtobufImage('')
          setPreviousCode('')
          setOpenSnackbar(true)
          setSnackbarMessage('Editor is empty. Please enter some code.')
          setSnackbarSeverity('warning')
          setOpenSnackbarDiagram(false)
          return
        }
        if (previousCode.trim() === editorValue.trim()) return
        setPreviousCode(editorValue)
        setOpenSnackbarDiagram(true)
        const outputImage = await generateProtobufDiagram(editorValue)
        if (outputImage != blankImage) {
          setProtobufImage(outputImage)
          localStorage.setItem('PROTOBUF_IMG', outputImage)
          setLoading(false)
          setOpenSnackbarDiagram(false)
        } else {
          setLoading(false)
          setOpenSnackbar(true)
          setSnackbarMessage('Compilation failed. Invalid input format')
          setSnackbarSeverity('error')
          setOpenSnackbarDiagram(false)
        }
      } catch (error) {
        console.error('Error generating protobuf diagram:', error)
        setLoading(false)
        setOpenSnackbar(true)
        setSnackbarMessage('Compilation failed. Invalid input format')
        setSnackbarSeverity('error')
      }
    }
    if (initial) {
      generateProtobufImage()
      setInitial(false)
    }

    if (!initial) {
      // const intervalId = setInterval(generateProtobufImage, 4000)
      // return () => clearInterval(intervalId)
      generateProtobufImage()
    }
    localStorage.setItem('selectedMode', CONSTANTS.PROTOBUF)
  }, [editorValue, previousCode, initial])

  return (
    <div className="alignMiddle" style={{ overflow: 'auto' }}>
      <MapContainer
        center={[51.505, -0.09]}
        zoom={13}
        attributionControl={false}
        zoomControl={false}
      >
     <PanZoom ref={panZoomRef} preventScroll= {true}>
          {loading && (
            <div className="alignMiddle">
              <CircularProgress />
              Executing...
            </div>
          )}
          
          {!loading && (protobufImage ?(
            <img
              src={`data:image/svg+xml;base64,${protobufImage}`}
              alt="Protobuf Diagram"
              className="image-style"
            />
          ) : (
            <div style={{ color: 'gray', fontSize: '24px' }}></div>
          ))}
        </PanZoom>
      </MapContainer>
    </div>
  )
}
export default Protobuf
